export default __webpack_public_path__ + "static/media/Nunito-Light.b9b8eae1.woff2";